import React, { useEffect, useState } from "react";
import Plus from "../../static/plus.svg";
import Modif from "./modif";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";

import "react-perfect-scrollbar/dist/css/styles.css";
import {
  Box,
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Stack,
  TextareaAutosize,
  Link,
  Dialog,
} from "@mui/material";
const apiUrl =
  window.location.hostname === "localhost"
    ? "https://localhost:7142/api"
    : "/api";
export default function Fiche() {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const location = useLocation();
  const { id } = useParams();
  const Id =
    location.state && location.state.id !== undefined ? location.state.id : id;
  const OpenEmployee = () => {
    setIsDialogOpen(true);
  };

  const CloseEmployee = () => {
    setIsDialogOpen(false);
  };
  const [employeeData, setEmployeeData] = useState<any>(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/Employee/${Id}`);
        setEmployeeData(response.data);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    fetchData();
  }, [Id]);


  return (
    <div
      style={{
        backgroundColor: "#F0F4F8",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width:"100%"
      }}
    >
      <Paper sx={{ padding: "20px", maxWidth: "1200px" }} className="newdpt">
        {employeeData ? (
          <form>
            <Typography
              fontWeight="bold"
              paddingY={2}
              borderRadius={3}
              textAlign="center"
              sx={{
                fontFamily: "'Poppins', sans-serif",
                color: "#0C4C92",
                backgroundColor: "#F0F4F8",
              }}
            >
              Restaurant "Il Sogno" - Salle
            </Typography>
            <Grid
              container
              marginTop={4}
              marginBottom={4}
              paddingBottom={4}
              display="flex"
              sx={{
                borderBottom: "2px solid rgba(0,0,0,0.1)",
              }}
            >
              <Grid
                item
                xs={12}
                lg={2}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box
                  width="200px"
                  padding="15px"
                  height="200px"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  position="relative"
                >
                  <img
                    src={employeeData.profilePicture}
                    alt={employeeData.name}
                    width={140}
                    height={140}
                    style={{
                      borderRadius: "50%",
                      position: "absolute",
                      boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                  <Stack
                    display="flex"
                    flexDirection="row"
                    paddingY={1}
                    sx={{
                      position: "relative",
                      zIndex: 1,
                      top: 80,
                      fontFamily: "'Poppins', sans-serif",
                      backgroundColor: "#F4F4F4",
                      color: "rgba(0,0,0,0.6)",
                      boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Typography
                      fontWeight="bold"
                      fontSize="0.7rem"
                      mx={2}
                      textAlign="center"
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      Total points
                    </Typography>
                    <Typography
                      mx={2}
                      fontWeight="bold"
                      fontSize="0.7rem"
                      textAlign="center"
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        backgroundColor: "#F4F4F4",
                        color: "#65BD56",
                      }}
                    >
                      397{" "}
                    </Typography>
                  </Stack>
                </Box>
              </Grid>
              <Grid item container xs={12} lg={10}>
                <Grid item container display="flex" xs={12}>
                  <Grid
                    container
                    item
                    display="flex"
                    justifyContent="start"
                    spacing={5}
                    alignItems="center"
                    marginX={2}
                  >
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="nom-prénom"
                        style={{ color: "rgba(0,0,0,0.6)", fontWeight: "bold" }}
                      >
                        Nom et prénom
                      </InputLabel>

                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-prénom"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData?.nom} {employeeData?.prenom}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="nom-du-service"
                        style={{ color: "rgba(0,0,0,0.6)", fontWeight: "bold" }}
                      >
                        Poste
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-du-service"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData?.poste}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="nom-du-service"
                        style={{ color: "rgba(0,0,0,0.6)", fontWeight: "bold" }}
                      >
                        Résponsabilité
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-du-service"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData.responsabilite}
                      </Typography>
                    </Grid>
                    <Grid item xs={1.5}>
                      <InputLabel
                        htmlFor="nom-du-service"
                        style={{ color: "rgba(0,0,0,0.6)", fontWeight: "bold" }}
                      >
                        Service
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-du-service"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData?.service}
                      </Typography>
                    </Grid>
                    <Grid item xs={2.5}>
                      <InputLabel
                        htmlFor="nom-du-service"
                        style={{ color: "rgba(0,0,0,0.6)", fontWeight: "bold" }}
                      >
                        Email
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-du-service"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData?.email}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="nom-du-service"
                        style={{ color: "rgba(0,0,0,0.6)", fontWeight: "bold" }}
                      >
                        N° de téléphone
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-du-service"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData.telephone}{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item container display="flex" xs={12}>
                  <Grid
                    container
                    item
                    display="flex"
                    justifyContent="start"
                    spacing={5}
                    alignItems="center"
                    marginX={2}
                  >
                    <Grid item xs={1.8}>
                      <InputLabel
                        htmlFor="nom-prénom"
                        style={{ color: "rgba(0,0,0,0.6)", fontWeight: "bold" }}
                      >
                        Type contrat
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-prénom"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData.contractType}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="nom-du-service"
                        style={{
                          color: "rgba(0,0,0,0.6)",
                          fontWeight: "bold",
                          overflow: "visible",
                        }}
                      >
                        Date d'embauche
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-du-service"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData.contractStartDate
                          ? new Date(
                              employeeData.contractStartDate
                            ).toLocaleDateString("fr")
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="nom-du-service"
                        style={{ color: "rgba(0,0,0,0.6)", fontWeight: "bold" }}
                      >
                        Date de fin{" "}
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-du-service"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData.contractEndDate
                          ? new Date(
                              employeeData.contractEndDate
                            ).toLocaleDateString("fr")
                          : "Jusqu'à ce jour"}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="nom-du-service"
                        style={{
                          color: "rgba(0,0,0,0.6)",
                          fontWeight: "bold",
                          overflow: "visible",
                        }}
                      >
                        Date de naissance{" "}
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-du-service"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData.dateNaissance
                          ? new Date(
                              employeeData.dateNaissance
                            ).toLocaleDateString("fr")
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={2.2}>
                      <InputLabel
                        htmlFor="nom-du-service"
                        style={{
                          color: "rgba(0,0,0,0.6)",
                          fontWeight: "bold",
                          overflow: "visible",
                        }}
                      >
                        Adresse{" "}
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-du-service"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData.addresse}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="nom-du-service"
                        style={{
                          color: "rgba(0,0,0,0.6)",
                          fontWeight: "bold",
                          overflow: "visible",
                          justifyContent: "end",
                          alignItems: "end",
                          display: "flex",
                        }}
                      >
                        contact cas d'urgence{" "}
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-du-service"
                        fontWeight="bold"
                        minHeight="35px"
                      >
                        {employeeData.urgence}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item container display="flex" xs={12}>
                  <Grid
                    container
                    item
                    display="flex"
                    justifyContent="start"
                    spacing={5}
                    alignItems="center"
                    marginX={2}
                  >
                    <Grid
                      container
                      item
                      display="flex"
                      justifyContent="space-between"
                      flexDirection="row"
                      alignItems="center"
                    >
                      <InputLabel
                        htmlFor="nom-prénom"
                        style={{ color: "rgba(0,0,0,0.6)", fontWeight: "bold" }}
                      >
                        Cantine
                      </InputLabel>
                      <Typography
                        my={1}
                        variant="body1"
                        id="nom-prénom"
                        fontWeight="bold"
                      ></Typography>
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#0B4B92",
                          borderRadius: "10px",
                        }}
                        type="submit"
                        onClick={(e) => {
                          e.preventDefault();
                          OpenEmployee();
                        }}
                      >
                        <Typography
                          fontWeight="bold"
                          fontSize="12px"
                          padding={1}
                          display="flex"
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "10px" }}
                          >
                            <path
                              d="M13.7002 7.58507C13.5102 7.58507 13.3202 7.6609 13.1902 7.79561C13.0502 7.93131 12.9802 8.11392 12.9802 8.30451V12.6231C12.9802 12.8137 12.9003 12.9973 12.7703 13.132C12.6303 13.2667 12.4503 13.3425 12.2603 13.3425H2.16028C1.97028 13.3425 1.78027 13.2667 1.65027 13.132C1.51027 12.9973 1.44019 12.8137 1.44019 12.6231V2.54704C1.44019 2.35646 1.51027 2.17391 1.65027 2.0382C1.78027 1.9035 1.97028 1.82766 2.16028 1.82766H6.49023C6.68023 1.82766 6.86024 1.75183 7.00024 1.61712C7.13024 1.48242 7.21021 1.29881 7.21021 1.10822C7.21021 0.916641 7.13024 0.734029 7.00024 0.599323C6.86024 0.463618 6.68023 0.387748 6.49023 0.387748H2.16028C1.58028 0.387748 1.03025 0.615285 0.630249 1.0204C0.220249 1.42552 -0.00976562 1.97429 -0.00976562 2.54704V12.6231C-0.00976562 13.1958 0.220249 13.7447 0.630249 14.1498C1.03025 14.5549 1.58028 14.7824 2.16028 14.7824H12.2603C12.8303 14.7824 13.3803 14.5549 13.7903 14.1498C14.1903 13.7447 14.4203 13.1958 14.4203 12.6231V8.30451C14.4203 8.11392 14.3402 7.93131 14.2102 7.79561C14.0702 7.6609 13.8902 7.58507 13.7002 7.58507ZM2.88025 8.13191V11.1842C2.88025 11.3748 2.96021 11.5574 3.09021 11.6931C3.23021 11.8278 3.41022 11.9037 3.60022 11.9037H6.66028C6.75028 11.9037 6.85019 11.8857 6.94019 11.8498C7.02019 11.8138 7.10029 11.761 7.17029 11.6951L12.1603 6.70698L14.2102 4.70634C14.2802 4.63948 14.3302 4.55967 14.3702 4.47186C14.4002 4.38405 14.4203 4.29028 14.4203 4.19549C14.4203 4.10069 14.4002 4.00686 14.3702 3.91905C14.3302 3.83124 14.2802 3.75143 14.2102 3.68458L11.1503 0.597313C11.0903 0.529461 11.0103 0.475558 10.9203 0.439637C10.8303 0.402717 10.7403 0.383789 10.6403 0.383789C10.5403 0.383789 10.4502 0.402717 10.3602 0.439637C10.2702 0.475558 10.1902 0.529461 10.1302 0.597313L8.09021 2.63389L3.09021 7.621C3.02021 7.68885 2.9703 7.76867 2.9303 7.85548C2.9003 7.94328 2.88025 8.03712 2.88025 8.13191ZM10.6403 2.12298L12.6803 4.15955L11.6603 5.18131L9.62024 3.14474L10.6403 2.12298ZM4.32019 8.42723L8.60022 4.15955L10.6403 6.19613L6.36023 10.4638H4.32019V8.42723Z"
                              fill="white"
                            />
                          </svg>
                          Edit
                        </Typography>
                      </Button>
                      <Dialog
                        className="editDialog"
                        sx={{ maxWidth: "100%" }}
                        open={isDialogOpen}
                        onClose={CloseEmployee}
                      >
                        <Modif
                          employeeData={employeeData}
                          onCancel={CloseEmployee}
                          id={Id}
                        />
                      </Dialog>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <div>
              <Grid
                container
                display="flex"
                flexDirection="row"
                justifyContent="space-around"
                sx={{
                  backgroundColor: "#F0F4F8",
                  color: "rgba(0,0,0,0.6)",
                }}
              >
                <Grid item xs={4}>
                  <Typography
                    fontWeight="semibold"
                    paddingLeft={6}
                    paddingBottom="10px"
                    paddingTop="10px"
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Points de vente{" "}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    fontWeight="semibold"
                    paddingLeft={6}
                    paddingBottom="10px"
                    paddingTop="10px"
                    textAlign="center"
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      color: "black",
                    }}
                  >
                    0{" "}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <a href="">
                    <Typography
                      fontWeight="semibold"
                      paddingLeft={6}
                      paddingBottom="10px"
                      paddingTop="10px"
                      marginRight={2}
                      textAlign="end"
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        backgroundColor: "#F0F4F8",
                      }}
                    >
                      Voir details{" "}
                    </Typography>
                  </a>
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid
                container
                display="flex"
                flexDirection="row"
                justifyContent="space-around"
                marginTop={2}
                sx={{
                  backgroundColor: "#F0F4F8",
                  color: "rgba(0,0,0,0.6)",
                }}
              >
                <Grid item xs={4}>
                  <Typography
                    fontWeight="semibold"
                    paddingLeft={6}
                    paddingBottom="10px"
                    paddingTop="10px"
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Points de mission{" "}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    fontWeight="semibold"
                    paddingLeft={6}
                    paddingBottom="10px"
                    paddingTop="10px"
                    textAlign="center"
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      color: "black",
                    }}
                  >
                    0{" "}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <a href="">
                    <Typography
                      fontWeight="semibold"
                      paddingLeft={6}
                      paddingBottom="10px"
                      paddingTop="10px"
                      marginRight={2}
                      textAlign="end"
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        backgroundColor: "#F0F4F8",
                      }}
                    >
                      Voir details{" "}
                    </Typography>
                  </a>
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid
                container
                display="flex"
                flexDirection="row"
                justifyContent="space-around"
                marginTop={2}
                sx={{
                  backgroundColor: "#F0F4F8",
                  color: "rgba(0,0,0,0.6)",
                }}
              >
                <Grid item xs={4}>
                  <Typography
                    fontWeight="semibold"
                    paddingLeft={6}
                    paddingBottom="10px"
                    paddingTop="10px"
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Points obtenu check list{" "}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    fontWeight="semibold"
                    paddingLeft={6}
                    paddingBottom="10px"
                    paddingTop="10px"
                    textAlign="center"
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      color: "black",
                    }}
                  >
                    0{" "}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <a href="">
                    <Typography
                      fontWeight="semibold"
                      paddingLeft={6}
                      paddingBottom="10px"
                      paddingTop="10px"
                      marginRight={2}
                      textAlign="end"
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        backgroundColor: "#F0F4F8",
                      }}
                    >
                      Voir details{" "}
                    </Typography>
                  </a>
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid
                container
                display="flex"
                flexDirection="row"
                justifyContent="space-around"
                marginTop={2}
                sx={{
                  backgroundColor: "#F0F4F8",
                  color: "rgba(0,0,0,0.6)",
                }}
              >
                <Grid item xs={4}>
                  <Typography
                    fontWeight="semibold"
                    paddingLeft={6}
                    paddingBottom="10px"
                    paddingTop="10px"
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    LQA{" "}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    fontWeight="semibold"
                    paddingLeft={6}
                    paddingBottom="10px"
                    paddingTop="10px"
                    textAlign="center"
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      color: "black",
                    }}
                  >
                    0{" "}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <a href="">
                    <Typography
                      fontWeight="semibold"
                      paddingLeft={6}
                      paddingBottom="10px"
                      paddingTop="10px"
                      marginRight={2}
                      textAlign="end"
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        backgroundColor: "#F0F4F8",
                      }}
                    >
                      Voir details{" "}
                    </Typography>
                  </a>
                </Grid>
              </Grid>
            </div>
            <Typography
              fontWeight="bold"
              marginTop={4}
              paddingY={2}
              textAlign="start"
              sx={{
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              One to one
            </Typography>
            <TextareaAutosize
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid rgba(0,0,0,0.6)",
              }}
              aria-label="minimum height"
              minRows={1}
            ></TextareaAutosize>
            <Grid container>
              <Grid container item lg={6}>
                <Grid
                  item
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  mx={1}
                >
                  <Typography fontWeight="bold">Actuellement</Typography>
                </Grid>
                <Grid item bgcolor="rgba(217,217,217,0.3)" mx={1}>
                  <Select variant="outlined" fullWidth sx={{ width: 150 }}>
                    <MenuItem
                      value="Travail"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: 150,
                      }}
                    >
                      Travail
                    </MenuItem>
                    <MenuItem
                      value="Repos"
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      Repos
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid
                  item
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography fontWeight="bold">Mission</Typography>
                </Grid>
                <Grid item bgcolor="rgba(217,217,217,0.3)" mx={1}>
                  <TextField id="nom-du-service" variant="outlined" fullWidth />
                </Grid>
              </Grid>
              <Grid container item lg={6} justifyContent="end">
                <Grid
                  item
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  mx={1}
                >
                  <Typography>Document à partager</Typography>
                </Grid>
                <Grid item bgcolor="rgba(217,217,217,0.3)" mx={1}>
                  <Select variant="outlined" fullWidth sx={{ width: 150 }}>
                    <MenuItem
                      value="Travail"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: 150,
                      }}
                    >
                      pdf
                    </MenuItem>
                    <MenuItem
                      value="Repos"
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      autre
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid
                  item
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  mx={1}
                >
                  <img src={Plus} alt="plus" width={30} height={30} />{" "}
                </Grid>
              </Grid>
            </Grid>
            <Grid container paddingY={2}>
              <Grid item display="flex" lg={9}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#62C300",
                    borderRadius: "10px",
                    fontSize: "0.7rem",
                    paddingY: 2,
                    paddingX: 5,
                    fontWeight: "bold",
                    marginRight: 5,
                  }}
                >
                  Mes horaires
                </Button>
                <Link
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  href={`/demande/${id}`}
                >
                  <svg
                    width="18"
                    height="11"
                    viewBox="0 0 18 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.00001 2.10991V0.114258H18V2.10991H4.00001ZM4.00001 6.1012V4.10556H18V6.1012H4.00001ZM4.00001 10.0925V8.09685H18V10.0925H4.00001ZM1.00001 2.10991C0.717008 2.10991 0.478995 2.01009 0.286995 1.8205C0.094995 1.63091 -0.000992267 1.39147 7.73311e-06 1.11208C7.73311e-06 0.832691 0.0960021 0.593253 0.288002 0.403666C0.480002 0.214079 0.717008 0.114258 1.00001 0.114258C1.28301 0.114258 1.52102 0.214079 1.71302 0.403666C1.90502 0.593253 2.00101 0.832691 2.00001 1.11208C2.00001 1.39147 1.90401 1.63091 1.71201 1.8205C1.52001 2.02006 1.28301 2.10991 1.00001 2.10991ZM1.00001 6.1012C0.717008 6.1012 0.478995 6.00138 0.286995 5.8118C0.094995 5.62221 -0.000992267 5.38277 7.73311e-06 5.10338C7.73311e-06 4.82399 0.0960021 4.58455 0.288002 4.39496C0.480002 4.20538 0.717008 4.10556 1.00001 4.10556C1.28301 4.10556 1.52102 4.20538 1.71302 4.39496C1.90502 4.58455 2.00101 4.82399 2.00001 5.10338C2.00001 5.38277 1.90401 5.62221 1.71201 5.8118C1.52001 6.01136 1.28301 6.1012 1.00001 6.1012ZM1.00001 10.0925C0.717008 10.0925 0.478995 9.99268 0.286995 9.80309C0.094995 9.61351 -0.000992267 9.37407 7.73311e-06 9.09468C7.73311e-06 8.81529 0.0960021 8.57585 0.288002 8.38626C0.480002 8.19668 0.717008 8.09685 1.00001 8.09685C1.28301 8.09685 1.52102 8.19668 1.71302 8.38626C1.90502 8.57585 2.00101 8.81529 2.00001 9.09468C2.00001 9.37407 1.90401 9.61351 1.71201 9.80309C1.52001 10.0027 1.28301 10.0925 1.00001 10.0925Z"
                      fill="black"
                    />
                  </svg>
                  <Typography
                    color="black"
                    fontWeight="bold"
                    fontSize="0.9rem"
                    marginLeft={1}
                  >
                    Liste demande
                  </Typography>
                </Link>
              </Grid>
              <Grid lg={3} display="flex" justifyContent="end">
                <Link
                  href={`/absence/${id}`}
                  sx={{
                    backgroundColor: "#003671",
                    borderRadius: "10px",
                    fontSize: "0.7rem",
                    paddingY: 2,
                    paddingX: 5,
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  Absences
                </Link>
              </Grid>
            </Grid>
          </form>
        ) : (
          <Typography>Loading...</Typography>
        )}
      </Paper>
    </div>
  );
}
